module.exports = __webpack_public_path__ + "static/media/report-title-default.bb6498f6.png";